module.exports = __webpack_public_path__ + "static/media/orange-edit-icon.8000c0eb.svg";